import { format, parse } from 'date-fns';

export const LE = '(le)';
export const GE = '(ge)';

export const handleFilterChange = (e, locFilters, setLocFilters) => {
  const { name, value } = e.target;
  setLocFilters({ ...locFilters, [name]: value });
};

export const getDateRange = (dateRange) => {
  const dateRangeKeys = Object.keys(dateRange);

  if (dateRangeKeys.length === 1) {
    const key = dateRangeKeys[0];
    const dtVal = format(
      parse(dateRange[key], 'dd-MM-yyyy', new Date()),
      'yyyy-MM-dd',
    );

    const newKey = key === GE ? 'contract_start[]' : 'contract_end[]';

    return { [newKey]: `${key}${dtVal}` };
  }

  if (dateRangeKeys.length === 2) {
    const ge = format(
      parse(dateRange[GE], 'dd-MM-yyyy', new Date()),
      'yyyy-MM-dd',
    );
    const le = format(
      parse(dateRange[LE], 'dd-MM-yyyy', new Date()),
      'yyyy-MM-dd',
    );

    return {
      'contract_start[]': `${GE}${ge}`,
      'contract_end[]': `${LE}${le}`,
    };
  }

  return {};
};

export const handleApply = (dateRange, locFilters, setFilters) => {
  if (Object.keys(locFilters).length || Object.keys(dateRange).length) {
    const filtersAndDateRange = {
      ...locFilters,
      ...getDateRange(dateRange),
    };
    setFilters(filtersAndDateRange);
  }
};

export const handleReset = (dateRange, filters, setFilters, setLocFilters, setDateRange) => {
  setLocFilters({});
  setDateRange({});

  if (Object.keys(filters).length || Object.keys(dateRange).length) {
    setFilters({});
  }
};

export const handleFromToDateChange = (date, key, dateRange, setDateRange) => {
  if (date === null) {
    const newDateRange = dateRange;
    delete newDateRange[key];
    setDateRange({ ...newDateRange });
    return undefined;
  }
  setDateRange({ ...dateRange, [key]: format(date, 'dd-MM-yyyy') });
  return undefined;
};

export const getMaxFromDate = (dateRange) => (dateRange[LE]
  ? parse(dateRange[LE], 'dd-MM-yyyy', new Date())
  : null);

export const getMinToDate = (dateRange) => (dateRange[GE]
  ? parse(dateRange[GE], 'dd-MM-yyyy', new Date())
  : null);
